const problems = [
  {
    icon: 'ri-list-check-3',
    title: 'Too Many Choices',
    description: 'Hundreds of products across dozens of brands with no way to compare them side by side. It\'s overwhelming and time-consuming.',
    color: 'bg-rose-50',
    iconColor: 'text-rose-500',
  },
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Confusing Finance & ROI',
    description: 'Understanding payback periods, rebates, feed-in tariffs and financing options requires piecing together information from multiple sources.',
    color: 'bg-primary-50',
    iconColor: 'text-primary-500',
  },
  {
    icon: 'ri-user-search-line',
    title: 'Hard To Compare Installers',
    description: 'Finding trusted, qualified installers with transparent pricing and verified reviews is a fragmented and frustrating experience.',
    color: 'bg-secondary-50',
    iconColor: 'text-secondary-500',
  },
  {
    icon: 'ri-puzzle-line',
    title: 'No Single Platform',
    description: 'The journey from research to installation spans disconnected websites, phone calls, and paperwork — nothing brings it together.',
    color: 'bg-accent-50',
    iconColor: 'text-accent-500',
  },
];

export default function ProblemSection() {
  return (
    <section id="problem" className="relative py-20 md:py-28 px-4 md:px-6 lg:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-start mb-14 md:mb-20">
          <div>
            <span className="inline-block text-xs font-semibold tracking-widest uppercase text-primary-600 mb-4">The Challenge</span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight leading-tight" style={{ color: '#111827' }}>
              Renewable Energy Should Be
              <span className="relative ml-3 italic font-serif" style={{ color: '#2FA84F' }}>
                Easier To Choose
              </span>
            </h2>
          </div>
          <div className="flex items-end">
            <p className="text-base md:text-lg text-foreground-600 leading-relaxed">
              Buying renewable energy is often confusing. Customers have to compare products, understand finance, find trusted installers, check rebates, calculate ROI and manage installation all in separate places. <strong>AK Energy brings the process together.</strong>
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {problems.map((item, i) => (
            <div
              key={item.title}
              className={`group relative ${item.color} rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-default`}
              style={{ animationDelay: `${i * 100}ms` }}
            >
              <div className="relative z-10 p-6 md:p-7">
                <div className={`w-12 h-12 rounded-xl bg-white flex items-center justify-center mb-5 transition-transform duration-300 group-hover:scale-110`}>
                  <i className={`${item.icon} ${item.iconColor} text-2xl`}></i>
                </div>
                <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
              </div>
              <div className="absolute top-0 right-0 w-24 h-24 rounded-bl-full opacity-10 bg-white" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}